import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Layouts from '@components/Layouts'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    component: Layouts['L-NS'],
    children: [
      {
        path: '',
        name: 'Index',
        component: () => import('@views/Index.vue')
      }
    ]
  },
  {
    path: '/index',
    component: Layouts['L-NS'],
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        component: () => import('@views/Index.vue')
      }
    ]
  },
  {
    path: '/onboarding',
    component: Layouts['_-_'],
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: 'Onboarding',
        redirect: { name: 'Onboarding:Slides' }
      },
      {
        path: 'slides',
        component: Layouts['_-S'],
        children: [{
          path: '',
          name: 'Onboarding:Slides',
          component: () => import('@views/Onboarding/Slides.vue')
        }]
      },
      {
        path: 'agreements',
        component: Layouts['L-_'],
        children: [{
          path: '',
          name: 'Onboarding:Agreements',
          props: ({ query: { from } }) => ({ from }),
          component: () => import('@views/Onboarding/Agreements.vue')
        }]
      }
    ]
  },
  {
    path: '/goal',
    component: Layouts['F-S'],
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: 'Goal:Start',
        component: () => import('@views/Goal/Start.vue')
      },
      {
        path: 'input',
        name: 'Goal:Input',
        props: ({ query: { edit } }) => ({ edit }),
        component: () => import('@views/Goal/Input.vue')
      },
      {
        path: 'feedback',
        name: 'Goal:Feedback',
        props: ({ query: { variant } }) => ({ variant }),
        component: () => import('@views/Goal/Feedback.vue')
      }
    ]
  },
  {
    path: '/track',
    component: Layouts['F-NS'],
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: 'Track',
        component: () => import('@views/Track.vue')
      }
    ]
  },
  {
    path: '/connect',
    component: Layouts['F-NS'],
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: 'Connect',
        component: () => import('@views/Connect.vue')
      }
    ]
  },
  {
    path: '/viewer',
    component: Layouts['L-_'],
    children: [
      {
        path: '',
        name: 'Viewer',
        props: ({ query: { page } }) => ({ page }),
        component: () => import('@views/PageViewer.vue')
      }
    ]
  },
  {
    path: '/pg',
    component: Layouts['L-_'],
    children: [
      {
        path: '',
        name: 'Playground',
        component: () => import('@views/Playground.vue')
      }
    ]
  },
  {
    path: '/learning',
    component: Layouts['F-NS'],
    meta: {
      requiresAuth: true
    },
    redirect: { name: 'Learning:Articles' },
    children: [
      {
        path: '',
        name: 'Learning:Articles',
        props: ({ query: { categoryId } }) => ({ categoryId }),
        component: () => import('@views/Learning/Articles.vue')
      },
      {
        path: 'article',
        name: 'Learning:Article',
        props: ({ query: { id } }) => ({ id }),
        component: () => import('@views/Learning/Article.vue')
      },
      {
        path: 'bookmarks',
        name: 'Learning:Bookmarks',
        component: () => import('@views/Learning/Bookmarks.vue')
      },
      {
        path: 'search',
        name: 'Learning:Search',
        props: ({ query: { q } }) => ({ q }),
        component: () => import('@views/Learning/Search.vue')
      }
    ]
  },
  {
    path: '*',
    component: () => import('@views/404.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
